import {NAME_SPACE, Platforms} from "@kta20-core/constants";
import {IStorage} from "@kta20-core/interfaces/i-storage";

export const Events = {
    ON_DEVICE_READY:NAME_SPACE+'.deviceready',
    ON_RESUME:NAME_SPACE+'.resume',
    ON_PAUSE:NAME_SPACE+'.pause',
    ON_BACK:NAME_SPACE+'.backbutton',
    ON_SEARCH:NAME_SPACE+'.searchbutton',
    ON_MENU:NAME_SPACE+'.menubutton',
    ON_KEYBOARD_WILL_SHOW:NAME_SPACE+'.keyboard-will-show',
    ON_KEYBOARD_DID_SHOW:NAME_SPACE+'.keyboard-did-show',
    ON_KEYBOARD_WILL_HIDE:NAME_SPACE+'.keyboard-will-hide',
    ON_KEYBOARD_DID_HIDE:NAME_SPACE+'.keyboard-did-hide',
};

export interface IAppContext {
    _platform: Platforms;
    _deploymentProfile: string;
    _ctxAPI: any;
    _objectStorage:IStorage;
    _uiEngine:any;
    _isReady:boolean;

    readonly platform: Platforms;
    readonly deploymentProfile: string;
    readonly ctxAPI: any;
    readonly objectStorage;
    readonly uiEngine:any;

    configure():void;

    isReady():boolean;

    renderMain(name:string,opts:any):Promise<void>;

    /**
     *
     * @param filePath
     * @param mimeType
     * @param options
     * @throws {MissingPluginError}
     */
    openFile(filePath:string, mimeType:string, options?:any):Promise<void>;

    /**
     *
     * @param nameToUser
     * @param blob
     * @param imeType
     * @throws {MissingPluginError | ResolveFsError | FsWriteError}
     */
    downloadFileAsBlob(nameToUser:string, blob:Blob, imeType:string):Promise<string>;

    addOnPauseListener(handler): void;
    removeOnPauseListener(handler): void;

    addOnResumeListener(handler): void;
    removeOnResumeListener(handler): void;

    addOnDeviceReadyListener(handler): void;
    removeOnDeviceReadyListener(handler): void;

    addOnSearchListener(handler): void;
    removeOnSearchListener(handler): void;

    addOnMenuListener(handler): void;
    removeOnMenuListener(handler): void;

    addOnBackListener(handler): void;
    removeOnBackListener(handler): void;

    addOnKeyboardWillShowListener(handler):void;
    removeOnKeyboardWillShowListener(handler): void;

    addOnKeyboardDidShowListener(handler):void;
    removeOnKeyboardDidShowListener(handler): void;

    addOnKeyboardWillHideListener(handler):void;
    removeOnKeyboardWillHideListener(handler): void;

    addOnKeyboardDidHideListener(handler):void;
    removeOnKeyboardDidHideListener(handler): void;
}